<!-- Answers: which weekdays are busiest (bookings + players) in the selected timeline. -->
<template>
    <dashboard-panel title="Most popular days" :subtitle="`Based on selected timeline: ${selectedRangeLabel}`">
        <dashboard-bar-chart-host
            wrap-class="compact"
            :labels="dayLabels"
            :datasets="dayDatasets"
            :extra-options="popularBarChartOptions"
        />
    </dashboard-panel>
</template>

<script setup>
import DashboardBarChartHost from "./DashboardBarChartHost.vue";
import DashboardPanel from "./DashboardPanel.vue";

const props = defineProps({
    selectedRangeLabel: { type: String, required: true },
    dayLabels: { type: Array, default: () => [] },
    dayDatasets: { type: Array, default: () => [] },
});

/** No fixed y stepSize=1 — player totals can exceed booking counts (co-located with these charts). */
const popularBarChartOptions = {
    scales: {
        y: {
            ticks: { maxTicksLimit: 12 },
        },
    },
};
</script>

